/* src/app/account/partials/lead-section/lead-section.component.scss */
/*# sourceMappingURL=lead-section.component.css.map */
